module.exports = __webpack_public_path__ + "assets/img/landing-top_bg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/landing-top_bg.svg
// module id = 1982
// module chunks = 0